import { AccessDeniedError, UnexpectedError } from "../../domain/errors";
import { UnauthorizedError } from "../../domain/errors/unauthorized-error";
import { Cargo } from "../../domain/models/cargo-model";
import { LoadCargo } from "../../domain/usecases/load-cargo";
import { HttpClient, HttpStatusCode } from "../protocols/http";

export class DbLoadCargo implements LoadCargo {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}
  async load(cargoReference: string): Promise<Cargo | null> {
    const res = await this.httpClient.request({
      url: this.url,
      method: "get",
      params: { cargoReference },
    });
    switch (res.statusCode) {
      case HttpStatusCode.ok:
        return res.body;
      case HttpStatusCode.forbidden:
        throw new AccessDeniedError();
      case HttpStatusCode.unauthorized:
        throw new UnauthorizedError();

      default:
        throw new UnexpectedError();
    }
  }
}
